<template>
  <div class="z-10 absolute bottom-7 left-[43%] flex justify-between bg-gray-50">
    <div>
      <a
        @click="changePage(page - 1)"
        class="block pl-3 py-2 cursor-pointer text-gray-500 hover:text-gray-700"
        :class="{
          'pointer-events-none': page == minPage,
        }"
      >
        <span class="sr-only">Previous</span>
        <svg
          aria-hidden="true"
          class="w-6 h-6"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
            clip-rule="evenodd"
          ></path>
        </svg>
      </a>
    </div>
    <div class="w-[100%] max-w-[54vw] overflow-x-auto bg-gray-50 pt-3">
      <ol class="items-center sm:flex">
        <div v-for="item in dates" :key="item">
          <li class="relative mb-6 sm:mb-0">
            <div class="flex items-center">
              <div
                class="z-10 flex items-center justify-center w-3 h-3 bg-blue-100 rounded-full dark:bg-blue-900 shrink-0"
                :class="date(selectedDate) == item ? 'bg-blue-700' : ''"
                @click="clickTime(item)"
              ></div>
              <div class="hidden sm:flex w-full bg-gray-200 h-0.5 dark:bg-gray-700"></div>
            </div>
            <div class="mt-3 sm:pe-8 px-0.5">
              <time
                class="block mb-2 text-xs w-7 font-normal leading-none text-gray-400 dark:text-gray-500"
              >
                {{ convertDate(item, "DD") }}
              </time>
            </div>
          </li>
        </div>
      </ol>
      <div class="flex justify-center text-xs text-gray-500 py-1">
        {{ currentMonth }}
      </div>
    </div>

    <div>
      <a
        @click="changePage(page + 1)"
        class="block pr-3 py-2 cursor-pointer text-gray-500 hover:text-gray-700"
        :class="{
          'pointer-events-none': page == maxPage,
        }"
      >
        <span class="sr-only">Next</span>
        <svg
          aria-hidden="true"
          class="w-6 h-6"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
            clip-rule="evenodd"
          ></path>
        </svg>
      </a>
    </div>
  </div>
</template>
<script>
import moment from "moment";

export default {
  props: {
    page: {
      default: 1,
      type: Number,
    },
    dates: Array,
    selectedDate: String,
    currentMonth: {
      type: String,
      default: "",
    },
    minPage: {
      type: Number,
      default: 1,
    },
    maxPage: {
      type: Number,
      default: 1,
    },
  },
  setup(props, { emit }) {
    function changePage(item) {
      emit("update:page", item);
      emit("onSelectChange", item);
    }

    function date(date) {
      return moment(date).format("MM/DD");
    }

    function clickTime(value) {
      emit("update:selectedDate", value);
      emit("onClickTime", value);
    }

    const convertDate = (value, format) => {
      return moment(value).format(format);
    };

    return {
      changePage,
      date,
      clickTime,
      convertDate,
    };
  },
};
</script>
<style></style>
